import React, { useEffect } from 'react';
import { Box, Button, Icon, Typography, useMediaQuery } from '@mui/material';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import SidebarStore from 'store/ui/sidebarStore';
import domainData from 'store/domainStore';
import M from 'messages';
import { routes } from 'config';

import classes from './styles';

function SideBarFooter({ isSidebarOpened }) {
  const downSM = useMediaQuery('(max-width:980px)');
  const isUserSuperAdmin = domainData.userIsSuperAdmin();

  useEffect(() => {
    SidebarStore.toggleSidebarByValue(!downSM);
  }, [downSM]);

  return (
    <footer>
      <Box
        sx={{
          ...classes.root,
          ...(isSidebarOpened && classes.rootDrawerOpen),
          ...(!isSidebarOpened && classes.rootDrawerClose),
        }}>
        {isSidebarOpened && (
          <Box>
            {!isUserSuperAdmin && (
              <Box sx={classes.upgradeCardContainer}>
                {/* Shimmer Layer */}
                <Box sx={classes.upgradeCardShimmer} />
                <Box sx={classes.upgradeCard}>
                  <Box sx={classes.upgradeHeader}>
                    <Icon baseClassName="material-symbols-outlined" sx={classes.upgradeTitleIcon}>
                      crown
                    </Icon>
                    <Typography sx={classes.upgradeTitle}>{M.get('sidebar.upgradeTitle')}</Typography>
                  </Box>
                  <Typography sx={classes.upgradeDescription}>{M.get('sidebar.upgradeDescription')}</Typography>
                  <Button component={Link} to={routes.subscriptions.path} sx={classes.upgradeButton} disableElevation>
                    <Icon baseClassName="material-symbols-outlined" sx={classes.upgradeButtonIcon}>
                      auto_awesome
                    </Icon>
                    {M.get('sidebar.upgradeButton')}
                  </Button>
                </Box>
              </Box>
            )}
            <Box sx={classes.footerTexts}>
              <Box sx={classes.versionText}>
                <Typography sx={{ ...classes.footerTypographies, ...classes.version }}>
                  {`${M.get('footer.version')} 1.2.1`}
                </Typography>
                <Typography sx={{ ...classes.footerTypographies, ...classes.copyRight }}>
                  {M.get('footer.copyright')}
                </Typography>
              </Box>
            </Box>
          </Box>
        )}
      </Box>
    </footer>
  );
}

SideBarFooter.propTypes = {
  isSidebarOpened: PropTypes.bool.isRequired,
};

export default SideBarFooter;
